export const SCROLL_THRESHOLD = 10;

export const SEARCHABLE_FIELDS = ['point_group', 'phase'];

export const DEFAULT_SORT_BY_TABLE_TYPE = {
  'switchgear-counter': 'operation_count',
  'motor-runtime': 'number_of_starts',
};

export const STATUS_LABELS = {
  ok: 'Running',
  unknown: 'Not running',
};

export const SWITCHGEAR_STATUS_LABELS = {
  ok: 'Present status: open',
  unknown: 'Present status: closed',
};

export const MOTOR_STATUS_LABELS = {
  ok: 'Present status: running',
  unknown: 'Present status: stopped',
};
